import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import user from './modules/user'
import count from './modules/count'
import meetingtime from './modules/meetingtime'
import pointvuex from './modules/pointvuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  // modules: { user, count, meetingtime }, getters
  modules: { user, count, meetingtime, pointvuex }, getters
})

export default store
